import { useEffect, useState } from "react";
import { useApiClient } from "../../../../shared/customHooks";
import { useApplicationContext } from "../../context/applicationContext";
import BaseComponent from "../../../../shared/baseComponent/BaseComponent";
import { appealOutcomeFormLegacy } from "../../../../shared/formObjects/application/legacy/appealOutcomeFormLegacy";

export default function appealOutcomeComponentLegacy({ disabled, data }: any) {
  const { fetchData } = useApiClient("UserManagement", { identity: true });
  const formApi = useApiClient("AppealOutcome");
  const { application, id } = useApplicationContext();

  const [context, setContext] = useState<IContext>({
    options: [],
    prevApplicationId: application.prevApplicationId,
  });

  useEffect(() => {
    fetchData("GetActiveUsersByRoles/2,3").then((res) => {
      const options = (res.data as any[])
        .map((user) => ({
          label: user.displayName,
          value: user.userEmail,
        }))
        .sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
      setContext((c) => ({ ...c, options }));
    });
  }, []);

  return (
    <>
      {application.prevApplicationId && (
        <BaseComponent
          formBody={appealOutcomeFormLegacy}
          headerLabel="Appeal Outcome"
          editPath="appealOutcome"
          apiClient={formApi}
          disabled={disabled}
          data={data}
          formContext={context}
          id={id}
        />
      )}
    </>
  );
}
interface IContext {
  options: any[];
  prevApplicationId?: number;
}
